var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_4966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 1.5H4.66667C2.92 1.5 1.5 2.92 1.5 4.66667V11.3333C1.5 13.08 2.92 14.5 4.66667 14.5H7.33333C7.97333 14.5 8.5 13.9733 8.5 13.3333V8.5H13.3333C13.9733 8.5 14.5 7.97333 14.5 7.33333V4.66667C14.5 2.92 13.08 1.5 11.3333 1.5ZM7.5 13.3333C7.5 13.4267 7.42667 13.5 7.33333 13.5H4.66667C3.47333 13.5 2.5 12.5267 2.5 11.3333V8.5H7.5V13.3333ZM7.5 7.5H2.5V4.66667C2.5 3.47333 3.47333 2.5 4.66667 2.5H7.5V7.5ZM13.5 7.33333C13.5 7.42667 13.4267 7.5 13.3333 7.5H8.5V2.5H11.3333C12.5267 2.5 13.5 3.47333 13.5 4.66667V7.33333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 11.5H12.5V10C12.5 9.72667 12.2733 9.5 12 9.5C11.7267 9.5 11.5 9.72667 11.5 10V11.5H10C9.72667 11.5 9.5 11.7267 9.5 12C9.5 12.2733 9.72667 12.5 10 12.5H11.5V14C11.5 14.2733 11.7267 14.5 12 14.5C12.2733 14.5 12.5 14.2733 12.5 14V12.5H14C14.2733 12.5 14.5 12.2733 14.5 12C14.5 11.7267 14.2733 11.5 14 11.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_4966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(1.5 1.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddColumn);
export default __webpack_public_path__ + "static/media/addColumn.e16193fc39cc6ea346f3ee5cb83eb953.svg";
export { ForwardRef as ReactComponent };